import { EnumerationDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import { FORM } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { __ANY_FORM } from '../ListSegConstants';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import once from 'transmute/once';
import unescapedText from 'I18n/utils/unescapedText';
export default once(() => DSFieldRecord({
  displayType: EnumerationDisplayType,
  displayOrder: -1,
  label: unescapedText('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyForm'),
  name: __ANY_FORM,
  type: FORM
}));